<!-- 充值页面 -->
  <template>
  <div>
    <div class="banxin">
      <div class="logobtns">
        <h1 @click="gohome()" class="logo"></h1>
        <!-- <button class="regbtn"  @click="goRecharge()">Recharge</button>  -->
      </div>

    </div>
    <div class="rechargebox">
      <!-- <div class="logobox">  <h1 class="logo"></h1>   </div> -->
      <p class="title1">Account to be recharged</p>
      <p class="txt1">Please check account information</p>
      <div class="inputs">
        <input :class="!checkuid?'noid':''" @focus="checkuid =true" v-model="uid" placeholder="Please enter your Mango ID" type="text">
        <button @click="Userinfo()">Check</button>
      </div>
      <div v-if="userinfo.uid" class="userinfo">
        <img :src="userinfo.head" alt="">
        <p>
          <span>{{userinfo.name}}</span>
          <span>ID: {{userinfo.uid}}</span>
        </p>
      </div>

      <div class="dropdownbox pcbox">
        <p class="title">Country / Region</p>

        <el-select v-model="Indonesia_select" popper-class='pcoption' :change="countrychange()">
          <el-option v-for="item in options" :key="item.countryCode" :label="item.countryName" :value="item.countryCode">
          </el-option>
        </el-select>
      </div>
      <div class="methodbox">
        <p class="title">Recharge method </p>
        <div class="method_btns">
          <button v-for="(item,index ) in method_btn" :key="index" @click="handleMethos(item,index) " :class="method_btnindex==index?'active':'' ">{{item}}</button>
          <!-- <button>Dana</button>
            <button>Linkaja</button> -->
        </div>
        <div v-if="needMobile" class="mobile-shell">
          <span>+62</span>
          <input class="mobile" v-model="mobile" type="text" placeholder="please fill in your Phone number for payment" />
        </div>
      </div>
      <div class="quantitybox">
        <p class="title">Recharge quantity <span class="Please_txt"></span></p>
        <ul>
          <li @click="cataLogDataindex =index " v-for="(item,index) in cataLogData[method_btn[method_btnindex]]" :key="index" :class="cataLogDataindex==index?'active':'' ">
            <span>{{item.amount}} Diamonds</span> <span>{{item.price}} {{item.priceUnit}}</span>
          </li>

        </ul>
      </div>
      <button @click="openRecharge" class="Rechargebtn">Recharge</button>
      <!-- <div v-if="Indonesia_select==60" style="margin-top:30px;width:100%;"><img style="width:100%;" src="@/assets/images/link/charge.png" alt=""></div> -->
      <div class="link">
        <ul>
          <li><img src="@/assets/images/link/1.png" alt=""></li>
          <li><img src="@/assets/images/link/2.png" alt=""></li>
          <li><img src="@/assets/images/link/3.png" alt=""></li>
          <li><img src="@/assets/images/link/4.png" alt=""></li>
          <li><img src="@/assets/images/link/5.png" alt=""></li>
          <li><img src="@/assets/images/link/6.png" alt=""></li>
          <li><img src="@/assets/images/link/7.png" alt=""></li>
          <li><img src="@/assets/images/link/8.png" alt=""></li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
// import Clipboard from 'clipboard';
export default {
  data() {
    return {
      uid: "", //17583910
      isuid: false, // 有UID
      checkuid: true, //校验UID
      userinfo: {
        uid: "",
      }, //
      Indonesia_select: "Indonesia",
      Indonesiasel: "Indonesia",
      options: [
        { countryCode: "62", countryName: "Indonesia" },
        { countryCode: "60", countryName: "Malaysia" },
      ],
      method_btn: [],
      method_btnindex: 0,
      cataLogData: {},
      cataLogDataindex: 0,
      needMobile: false,
      mobile: "",
    };
  },
  created() {
    this.arealist();
    //  this.cataloglist()
  },

  methods: {
    handleMethos(item, index) {
      if (!this.method_btn.length) return;
      this.method_btnindex = index;
      let arr = ["ovo", "linkaja"].map((item) => item.toLocaleUpperCase());

      let methodIndex = arr.findIndex(
        (value) => item.toLocaleUpperCase() == value.toLocaleUpperCase()
      );
      if (methodIndex < 0) {
        this.needMobile = false;
      } else {
        this.needMobile = true;
      }
    },
    arealist() {
      var _this = this;
      _this.$http.post(_this.$api.arealist).then(function (response) {
        console.log();
        _this.options = response.data.data;
        _this.Indonesia_select = _this.options[0].countryCode;
        _this.Indonesiasel = _this.options[0].countryCode;

        setTimeout(() => {
          _this.cataloglist();
        }, 100);
      });
    },
    cataloglist() {
      var _this = this;
      var code = _this.Indonesia_select;
      _this.$http
        .post(_this.$api.cataloglist, { countryCode: code })
        .then(function (response) {
          var _data = response.data.data.cataLogData;
          _this.method_btn = Object.keys(_data);
          _this.handleMethos(_this.method_btn[0], 0);
          _this.cataLogData = _data;
        });
    },
    Userinfo() {
      var _this = this;
      if (_this.uid == "") {
        _this.$message({
          customClass: "pcmsg",
          type: "error",
          message: "Please enter your Mango ID",
        });
        return;
      }

      _this.$http
        .post(_this.$api.userinfo, { uid: _this.uid })
        .then(function (response) {
          console.log(response);
          if (response.data.code == "S_OK") {
            _this.userinfo = response.data.data;
            _this.isuid = true;
            _this.checkuid = true;
          } else {
            _this.checkuid = false;
            _this.isuid = false;
            _this.userinfo = "";
            _this.$message({
              customClass: "pcmsg",
              type: "error",
              message: response.data.message,
            });
          }
        });
    },
    countrychange(data) {
      var _this = this;
      console.log(_this.Indonesia_select);
      if (_this.Indonesia_select == _this.Indonesiasel) {
        return;
      } else {
        setTimeout(() => {
          _this.cataloglist();
          _this.Indonesiasel = _this.Indonesia_select;
        });
      }
    },
    openRecharge() {
      var _this = this;
      if (!_this.isuid) {
        _this.checkuid = false;
        _this.$message({
          customClass: "pcmsg",
          type: "error",
          message: "Please enter your Mango ID and click 【Check】",
        });
        return;
      }
      if (
        ["OVO", "LINKAJA"].findIndex(
          (value) =>
            value ===
            _this.method_btn[_this.method_btnindex].toLocaleUpperCase()
        ) > -1 &&
        !_this.mobile
      ) {
        return message("please fill in your Phone number for payment");
      }
      var data = _this.cataLogData[_this.method_btn[_this.method_btnindex]];
      _this
        .$confirm(
          "Are you sure to recharge " +
            data[_this.cataLogDataindex].amount +
            " diamonds?",
          {
            confirmButtonText: "Sure",
            cancelButtonText: "Cancel",
            customClass: "pcconfirm",
          }
        )
        .then(() => {
          const loading = this.$loading({
            lock: true,
            customClass: "pcLoading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.3)",
          });
          _this.$http
            .post(_this.$api.docharge, {
              catalogCode: data[_this.cataLogDataindex].catalogCode,
              countryCode: data[_this.cataLogDataindex].countryCode,
              uid: _this.uid,
              mobile: _this.mobile && "+62" + _this.mobile,
            })
            .then(function (response) {
              console.log(response);
              loading.close();
              if (response.data.code == "S_OK") {
                // if (
                //   _this.method_btn[_this.method_btnindex].toLocaleUpperCase() ==
                //   "OVO"
                // ) {
                //   return _this.$message({
                //     customClass: "pcmsg",
                //     message: `The order has been created, please check your OVO Application and continued the process of
                // payment.`,
                //   });
                // }
                window.location.href = response.data.data.url;
                loading.close();
              } else {
                _this.$message({
                  customClass: "pcmsg",
                  type: "error",
                  message: response.data.message,
                });
              }
            });
        })
        .catch(() => {});
    },
    gohome() {
      this.$router.push({ path: "/pchome" });
    },
  },
};
</script>
<style lang="less" scoped>
.mobile-shell {
  margin-top: 10px;
  width: 100%;
  height: 40px;
  position: relative;
  span {
    position: absolute;
    font-size: 14px;
    top: 50%;
    transform: translateY(-51%);
    left: 5px;
  }
  .mobile {
    width: 100%;
    height: 40px;
    background: #f8f8f8;
    border-radius: 15px;
    font-size: 14px;
    box-sizing: border-box;
    padding: 0 36px;
  }
}

.rechargebox {
  padding-bottom: 0.5rem;
  width: 3.1rem;
  margin: 0 auto;
}
button:hover {
  opacity: 0.85;
}
.logobtns {
  width: 100%;
  height: 0.42rem;
  display: flex;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
  .logo {
    width: 1.04rem;
    height: 0.2rem;
    background: url("../../assets/images/liveimg/LOGO_phone@2x.png");
    background-size: 100% 100%;
  }
}
.logobox {
  padding: 0.8rem 0rem;
  box-sizing: border-box;
  .logo {
    width: 3.46rem;
    height: 0.6rem;
    background: url("../../assets/images/liveimg/LOGO_phone@2x.png");
    background-size: 100% 100%;
  }
}

.title1 {
  font-size: 0.11rem;
  font-weight: bold;
  color: rgba(48, 48, 48, 1);
  margin-bottom: 0.05rem;
}
.txt1 {
  font-size: 0.09rem;
  font-weight: 400;
  color: rgba(160, 160, 160, 1);
}
.inputs {
  padding: 0.15rem 0rem;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  input {
    width: 78%;
    background: rgba(248, 248, 248, 1);
    font-size: 0.1rem;
    border-radius: 0.09rem;
    height: 0.32rem;
    padding: 0 0.12rem;
    box-sizing: border-box;
  }
  input::-webkit-input-placeholder,
  textarea::-webkit-input-placeholder {
    font-size: 0.09rem;
    font-weight: 400;
    color: rgba(160, 160, 160, 1);
  }
  .noid {
    border: 1px solid rgba(237, 72, 72, 1);
    color: rgba(237, 72, 72, 1);
  }
  .noid::-webkit-input-placeholder,
  textarea::-webkit-input-placeholder {
    font-size: 0.09rem;
    font-weight: 400;
    color: rgba(237, 72, 72, 1);
  }

  button {
    width: 19%;
    height: 0.32rem;
    border-radius: 0.09rem;
    background: rgba(185, 67, 255, 1);
    font-size: 0.09rem;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
  }
}
.userinfo {
  background: url("../../assets/images/liveimg/phoneID@2x.png");
  background-size: 100% 100%;
  padding: 0 0.16rem;
  box-sizing: border-box;
  background-color: #f8f8f8;
  width: 100%;
  display: flex;
  align-items: center;
  height: 0.63rem;
  margin-bottom: 0.26rem;
  img {
    width: 0.42rem;
    height: 0.42rem;
    border-radius: 50%;
  }
  p {
    display: flex;
    flex-direction: column;
    margin-left: 0.17rem;
    color: #a0a0a0;
    font-size: 0.09rem;
    span:nth-child(1) {
      color: #303030;
      font-weight: bold;
      font-size: 0.11rem;
      margin-bottom: 0.05rem;
    }
  }
}
.title {
  font-size: 0.11rem;
  font-weight: bold;
  color: rgba(48, 48, 48, 1);
  .Please_txt {
    font-size: 0.09rem;
    font-weight: 400;
    color: rgba(255, 50, 63, 1);
  }
}
.dropdownbox {
  display: flex;
  justify-content: space-between;

  .el-select {
    color: rgba(48, 48, 48, 1);
    width: 1rem;
    height: 0.25rem;
    font-size: 0.09rem;
    background: #fff;
    border: 1px solid rgba(185, 67, 255, 1);
    border-radius: 0.09rem;
  }
}
.pcoption .el-select-dropdown__item {
  height: 0.3rem;
  line-height: 0.3rem;
  text-align: center;
  color: rgba(48, 48, 48, 1);
  font-size: 0.09rem;
}
.methodbox {
  margin-top: 0.3rem;
  .method_btns {
    display: flex;
    margin-top: 0.1rem;
    flex-wrap: wrap;
    justify-content: space-between;
    button {
      margin-top: 0.06rem;
      width: 1rem;
      padding: 0 0.03rem;
      color: rgba(48, 48, 48, 1);
      height: 0.25rem;
      font-size: 0.09rem;
      background: rgba(248, 248, 248, 1);
      border-radius: 0.07rem;
    }
    .active {
      background: rgba(243, 234, 255, 1);
      border: 1px solid rgba(170, 76, 250, 1);
      color: rgba(170, 76, 250, 1);
    }
  }
}
.quantitybox {
  margin-top: 0.3rem;
  ul {
    display: flex;
    flex-direction: column;
    width: 100%;
    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 0.2rem;
      padding: 0 0.12rem;
      box-sizing: border-box;
      font-size: 0.09rem;
      color: rgba(48, 48, 48, 1);
      width: 100%;
      height: 0.36rem;
      background: rgba(248, 248, 248, 1);
      border-radius: 0.09rem;
      span:nth-child(2) {
        font-weight: bold;
      }
    }
    .active {
      background: rgba(243, 234, 255, 1);
      border: 1px solid rgba(170, 76, 250, 1);
      color: rgba(170, 76, 250, 1);
    }
  }
}
.Rechargebtn {
  display: block;
  margin: 0.4rem auto 0 auto;
  width: 2.09rem;
  font-size: 0.11rem;
  height: 0.42rem;
  color: rgba(255, 255, 255, 1);
  background: rgba(185, 67, 255, 1);
  border-radius: 0.3rem;
}

.noactive {
  background: rgba(255, 239, 239, 1);
  border: 1px solid rgba(237, 72, 72, 1);
  color: #ed4848;
}
.link {
  width: 3.3rem;
  ul {
    display: flex;
    flex-wrap: wrap;
    margin-top: 0.3rem;
  }
  li {
    width: 0.75rem;
    margin: 0.02rem 0 0 0.02rem;
    justify-content: center;
    // border-radius: 10px;
    // overflow: hidden;
    img {
      width: 100%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/page/webpage/recharge.vue